export enum UnifiedProcedureRecordType {
  UNSPECIFIED = 'Unspecified',
  PROCEDURE_NOTE = 'Procedure note',
  PROCEDURE = 'Procedure',
}
